<template>
	<div 
		class="navmenu fixed md:hidden inset-0 bg-bg-002 text-text-002 text-xl"
		:class="{
			'active': isNavMenuVisible
		}"
	>
		<div class="flex flex-col h-full">
			<header class="w-full flex flex-row justify-center items-center border-b border-gray-004 px-5">
				<div class="logo">
					<UiLogo 
						mode="secondary"
						@click="logoClick()"
					/>
				</div>
			</header>
			<section class="content flex-1 px-5 pt-2 pb-4">
				<div>
					<UiButton
						type="icon"
						name="arrowLeft" 
						:icon-size="30"
						theme="transparent"
						:on-click="hideNavMenu"
					/>
				</div>
				<div class="mt-10 mb-7">
					<SearchBar id="navMenuSearch" border-color="white"/>
				</div>
				<nav class="nav">
					<CategoryAccordion 
						v-if="categories && categories.length > 0"
						class="h-100" 
						label="Categories"
						:list="categories"
						:list-height="maxAccordionHeight"
					/>
				</nav>
				<div>
					<UiButton
						v-if="!isAuth"
						label="Log In"
						width="auto"
						theme="transparent"
						:on-click="userLogin"
					/>
					<UiButton
						v-else
						label="Log Out"
						width="auto"
						theme="transparent"
						:on-click="userLogout"
					/>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiLogo from '@/components/ui/Logo'
import UiButton from '@/components/ui/Button'
import SearchBar from '@/components/search/Bar'
import CategoryAccordion from '@/components/category/Accordion'

export default {
	name: 'NavMenu',
	components: {
		UiLogo,
		UiButton,
		SearchBar,
		CategoryAccordion,
	},
	mixins: [
		globalMixins
	],
	props: {
		id: {
			type: String,
			default: 'navMenu'
		}
	},
	data() {
		return {
			maxAccordionHeight: '0px'
		}
	},
	watch: {
		$route() {
			this.hideNavMenu()
		}
	},
	beforeMount() {
		this.checkNavMenuVisibility()
    window.addEventListener('resize', this.pageResize);
	},
	beforeUnmount() {
    window.removeEventListener('resize', this.pageResize);
	},
	mounted() {
		const space = 150;
		const frame = this.$el.querySelector('.content')
		const children = frame.children
		let occupied = 0

		for (let i = 0; i < children.length; i++) {
			const el = children[i]
			occupied += this.getOuterHeight(el)
		}

		this.maxAccordionHeight = (this.getInnerHeight(frame) - occupied - space) + 'px'
	},
	methods: {
		pageResize() {
			if (window.innerWidth > 769) {
				this.hideNavMenu()
			}
		},
		logoClick() {
			this.analytics({
				event: 'Click',
				label: 'Logo | Home | Nav Menu'
			})
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.navmenu { 
	z-index: 999;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.2s linear;
}
.navmenu.active { 
	opacity: 1; 
	pointer-events: all;
}
.navmenu > header { height: var(--navbar-height-sticky-mobile) !important; }

.logo { width: var(--logo-width-sm); }

.nav { overflow: auto; }
.nav > * { margin-bottom: 0.75rem !important }

header { height: var(--navbar-height-sticky-mobile); }
</style>